<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">设备详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="名称" prop="DeviceName">
                <el-input
                  v-model="data.DeviceName"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编号" prop="JsonExtend.DeviceNo">
                <el-input
                  v-model="data.JsonExtend.DeviceNo"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="区域" prop="RegionId">
                <el-select
                  v-model="data.RegionId"
                  :disabled="!IsEdit"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in EqRegionArr"
                    :key="item.RegionId"
                    :label="item.RegionName"
                    :value="item.RegionId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地理位置" prop="JsonExtend.Position">
                <el-input
                  v-model="data.JsonExtend.Position"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" prop="Longitude">
                <el-input
                  v-model="data.Longitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="纬度" prop="Latitude">
                <el-input
                  v-model="data.Latitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <ZjLngLatSelect
              class="newtaskposition"
              :point_lat="data.Latitude"
              :point_lng="data.Longitude"
              @onGotLngLat="onGotLngLat"
            ></ZjLngLatSelect>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="设备类型" prop="DeviceType">
                <el-select
                  v-model="data.DeviceType"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="changeDeviceType"
                  :disabled="!IsEdit"
                >
                  <el-option
                    v-for="item in EqTypeArr"
                    :key="item.ItemKey"
                    :label="item.Description"
                    :value="item.ItemValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="ToiletIsShow">
            <el-col>
              <el-form-item label="厕所类型">
                <el-checkbox-group
                  v-model="checkedToiletType"
                  @change="handleCheckedToiletTypeChange"
                  :disabled="!IsEdit"
                >
                  <el-checkbox
                    v-for="tolit in TolitTypeArr"
                    :label="tolit.Description"
                    :key="tolit.Description"
                    >{{ tolit.Description }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <div v-for="(item, index) in TolitList" :key="index">
              <el-col :span="12">
                <el-form-item :label="item.ToiletName + `坑位`">
                  <el-input
                    v-model="item.ToiletValue"
                    type="number"
                    :disabled="!IsEdit"
                  ></el-input>
                </el-form-item>
              </el-col>
            </div>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人" prop="JsonExtend.Name">
                <el-input
                  v-model="data.JsonExtend.Name"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="JsonExtend.LinkPhone">
                <el-input
                  v-model="data.JsonExtend.LinkPhone"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";

export default {
  name: "POIManagerEdit",
  controller: "UI",
  action: "POIManagerEdit",
  data() {
    return {
      data: {
        RegionId: "",
        DeviceType: "",
        Latitude: "",
        Longitude: "",
        JsonExtend: {
          DeviceNo: null,
          NearBy: null,
          Ip: null,
          Port: 0,
          UserName: null,
          Password: null,
          Rtsp: null,
          IndexCode: null,
          EquipModel: null,
          WarrantyPeriod: null,
          CustomType: null,
          Position: null,
          LinkPhone: null,
          Name: null,
          OrderNo: 0,
          ManagementUnit: null,
          Introduction: null,
          IsShowPosition: null,
          FileId: null,
          Tolits: {},
        },
      },

      EqRegionArr: [],
      EqTypeArr: [],
      TolitTypeArr: [],
      TolitList: [],
      Tolits: {},
      checkedToiletType: [],
      IsEdit: false,
      ToiletIsShow: false,
      toiletNum: 0,
      rules: {
        DeviceName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
        ],
        "JsonExtend.DeviceNo": [
          { required: true, message: "请输入设备编号", trigger: "blur" },
        ],
        "JsonExtend.Name": [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        "JsonExtend.LinkPhone": [
          { required: true, message: "请输入联系人电话", trigger: "blur" },
        ],
        RegionId: [
          { required: true, message: "请选择区域", trigger: "change" },
        ],
        DeviceType: [
          { required: true, message: "请选择设备类型", trigger: "change" },
        ],
        Longitude: [
          {
            required: false,
            message: "请输入有效的经度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        Latitude: [
          {
            required: false,
            message: "请输入有效的纬度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
      },
    };
  },
  created: function () {
    this.getRegionInfo();
    this.getPOIType();
    this.getToiletType();
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  watch: {
    $route: function () {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    onGotLngLat(obj) {
      this.data.Latitude = obj.lat || 0;
      this.data.Longitude = obj.lng || 0;
    },
    getToiletType() {
      this.config
        .getUValue("ZJMap:POIType_Tolit", "")
        .then((d) => {
          this.TolitTypeArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    //获取POI类型
    getPOIType() {
      this.config
        .getUValue("ZJMap:POIType", "")
        .then((d) => {
          this.EqTypeArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    getRegionInfo() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionList()
        .GetRegionInfos(RegionInfo)
        .then((r) => {
          r = r.data.Data;
          console.log(r);
          this.EqRegionArr = r;
          // this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        let searchInfo = {
          deviceId: InfoId,
        };
        new MyApis.TranResourcesApi()
          .GetEquipmentById(searchInfo)
          .then((r) => {
            r = r.data.Data;
            this.data = r;
            this.data.JsonExtend = JSON.parse(this.data.JsonExtend);
            if (this.data.DeviceType == "SubSystem.Map.POIType.MapToilet") {
              this.ToiletIsShow = true;
            } else {
              this.ToiletIsShow = false;
            }
            if (this.data.JsonExtend.Tolits != null) {
              this.checkedToiletType = Object.keys(this.data.JsonExtend.Tolits);
              for (let i in this.data.JsonExtend.Tolits) {
                this.TolitList.push({
                  ToiletName: i,
                  ToiletValue: this.data.JsonExtend.Tolits[i],
                });
              }
            }
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      let uuid = "";
      if (this.$route.query.type == "edit") {
        uuid = this.$route.query.InfoId;
      } else {
        uuid = ZJApp.ZJUtils.uuid();
      }
      this.Tolits = {};
      this.TolitList.forEach((item) => {
        this.Tolits[item.ToiletName] = item.ToiletValue;
      });
      const RegionName = this.EqRegionArr.filter((item) => {
        return item.RegionId === this.data.RegionId;
      });
      this.data.RegionName = RegionName[0].RegionName;
      this.data.JsonExtend.CustomType = this.data.EquipmentType;
      this.data.JsonExtend.Tolits = this.Tolits;
      this.data.JsonExtend = JSON.stringify(this.data.JsonExtend);
      if (this.$route.query.type == "edit") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .UpdateEquipment(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "POI修改";
            this.logInfo.LogMessage = "POI修改";
            this.logInfo.ModuleName = "设备管理";
            this.logInfo.PageName = "POI管理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Validity: 1, //新增编辑是1，删除是0
          EquipmentType: "MapPOI",
          DeviceId: uuid,
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .AddEquipment(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "POI添加";
            this.logInfo.LogMessage = "POI添加";
            this.logInfo.ModuleName = "设备管理";
            this.logInfo.PageName = "POI管理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    handleCheckedToiletTypeChange(value) {
      this.TolitList = [];
      value.forEach((item) => {
        this.TolitList.push({ ToiletName: item, ToiletValue: 0 });
      });
    },
    changeDeviceType(value) {
      if (value == "SubSystem.Map.POIType.MapToilet") {
        this.ToiletIsShow = true;
      } else {
        this.ToiletIsShow = false;
        this.TolitList = [];
      }
    },
  },
};
</script>
